import { LevelItems } from "../CreateAndEditNotify/CreateAndUpdate";
import { NotifyFilterConfig as INotifyFilterConfig } from "./ExtensiveFilter";
import { IUserFilterConfig } from "../../userController/UserExtensiveSearch";

export interface CategoryFilterOption {
  label: string;
  value: string;
  className?: string;
}
export const NOTIFICATION_FILTER_CONFIG: INotifyFilterConfig[] = [
  {
    label: "Notification ID",
    key: "NUniqueID",
    type: "input",
    placeholder: "Enter Unique ID",
  },
  {
    label: "Title",
    key: "title",
    type: "input",
    placeholder: "Enter the title",
  },
  {
    label: "Created By",
    key: "createdBy",
    type: "input",
    placeholder: "Enter the name",
  },
  {
    label: "Updated By",
    key: "updatedBy",
    type: "input",
    placeholder: "Enter the name",
  },
  {
    label: "Category",
    key: "category",
    type: "select",
    options: [
      { label: "TARGET", value: "TARGET" },
      { label: "CRITICAL", value: "CRITICAL" },
      { label: "GENERAL", value: "GENERAL" },
    ],
  },
  {
    label: "Status",
    key: "status",
    type: "select",
    options: [
      { label: "Draft", value: "DRAFT" },
      { label: "Waiting", value: "WAITING" },
      { label: "Published", value: "PUBLISHED" },
      { label: "Recall", value: "RECALL" },
    ],
  },
  {
    label: "Created On",
    key: "createdOn",
    type: "date",
  },
  {
    label: "Updated On",
    key: "updatedOn",
    type: "date",
  },
];

export const USER_FILTER_CONFIG: IUserFilterConfig[] = [
  {
    label: "Username",
    key: "userName",
    type: "input",
  },
  {
    label: "Email",
    key: "email",
    type: "input",
  },
  {
    label: "SSO Roles",
    key: "ssoRoles",
    type: "select",
    options: [
      { label: "PCG Admin", value: "SSO_ADMIN" },
      { label: "PCG Broadcast Manger", value: "SSO_BROADCAST_MANAGER" },
    ],
  },
  {
    label: "OTP Status",
    key: "otp",
    type: "select",
    options: [
      { label: "Enabled", value: "true" },
      { label: "Disabled", value: "false" },
    ],
  },
  {
    label: "Account Status",
    key: "accountStatus",
    type: "select",
    options: [
      { label: "Locked", value: "LOCK" },
      { label: "Active", value: "UNLOCK" },
    ],
  },
  {
    label: "CC Email IDs",
    key: "ccEmailIds",
    type: "input",
  },
  {
    label: "Access Applications",
    key: "accessApplications",
    type: "select",
    options: [
      { label: "CTC", value: "9b697193-ded3-4716-9666-f2d24f5ae7f8" },
      { label: "CCT", value: "444c94ac-fdb6-4d3f-9992-7c1abfbc48ac" },
      { label: "Reports", value: "555594ac-fdb6-4d3f-9992-7c1abfbc48ac" },
      // { label: "Sso", value: "555594ac-fdb6-4d3f-9992-7c1abfbc48ac" },
    ],
  },
];

export const STATUS_FILTER_OPTIONS: CategoryFilterOption[] = [
  { label: "Draft", value: "DRAFT", className: " draft" },
  { label: "Waiting", value: "WAITING", className: " waiting" },
  { label: "Published", value: "PUBLISHED", className: " pulished" },
  { label: "Recall", value: "RECALL", className: " recall" },
];

export const CATEGORY_FILTER_OPTIONS: LevelItems[] = [
  { label: "TARGET", value: "TARGET" },
  { label: "CRITICAL", value: "CRITICAL" },
  { label: "GENERAL", value: "GENERAL" },
];

export const DBTilte = {
  NUniqueID: "NUniqueID",
  title: "GeneralDetails.Title",
  category: "GeneralDetails.NotificationType",
  status: "FinalStatus",
  createdBy: "CreatedBy.PerformedBy",
  createdOn: "CreatedBy.PerformedOn",
  updatedBy: "UpdatedBy.PerformedBy",
  updatedOn: "UpdatedBy.PerformedOn",
  level: "GeneralDetails.Level",
};
